<app-loader></app-loader>
<p-toast [breakpoints]="{ '420px': { width: '100%', right: '0', left: '0' } }"></p-toast>

<div class="date-filter">
    <div class="top-financial">    
        <div class="one-time">
            <ul>
                <li *ngFor="let option of bookingTypeOption">
                    <p-radioButton type="radio" id="{{option.value}}" [(ngModel)]="bookingType"
                        (click)="onBookingTypeChange(option.value)" [value]="option.value"></p-radioButton>
                    <label class="option-name" for="{{option.value}}">{{option.name}}</label>
                </li>
            </ul>
    
        </div>
    </div>
    <div class="grid">
        <div class="col-12 lg:col-2">
            <div class="date-outer">
                <label for="selectedParkingLots">Parking Lot<span class="custom-star">*</span></label>
                <div class="custom-select2">
                    <div class="filter-parking header-filter financials-filter">
                        <p-multiSelect id="selectedParkingLots" [options]="parkingLotByStatesListWithAll" 
                        [(ngModel)]="selectedParkingLots" 
                        optionLabel="name"
                        [defaultLabel]="'Select Parking Lots'"
                        (onChange)="onParkingLotSelectionChange($event)" >
                        </p-multiSelect>
                        <img src="assets/images/fill-dropdown.svg" alt="" />
                    </div>
                </div>
            </div>
            <div *ngIf="showParkingLotAsterisk" class="validation-error">This field is required*</div>
        </div>
        <div class="col-12 lg:col-2">
            <div class="date-outer">
                <label for="dateRange">Date Range</label>
                <div class="custom-select2">
                    <div class="filter-parking header-filter">
                        <p-dropdown id="dateRange" [options]="DateSlot" optionLabel="name" optionValue="value"
                            (onChange)="onDateSlotChange($event)"></p-dropdown><img
                            src="assets/images/fill-dropdown.svg" alt="" />
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf='showPicker' class="col-12 lg:col-2">
            <div class="date-outer">
                <label for="startDateTime">Start Date & Time</label>
                <div class="custom-select2 custom-date-calender">
                    <div class="filter-parking header-filter">
                        <p-calendar #calendarTopStartDateRef id="startDateTime" [(ngModel)]="startdate" [showTime]="true"
                            dateFormat="M dd, yy" [inputStyle]="{'width':'95%'}" [readonlyInput]="true"
                            placeholder="Select Date"></p-calendar><img [calendarOpener]="calendarTopStartDateRef"
                            src="assets/images/date-calender.png" alt="calender"/>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf='showPicker' class="col-12 lg:col-2">
            <div class="date-outer">
                <label for="endDateTime">End Date and Time</label>
                <div class="custom-select2 custom-date-calender">
                    <div class="filter-parking header-filter">
                        <p-calendar #calendarTopEndDateRef id="endDateTime" [(ngModel)]="enddate" [showTime]="true" dateFormat="M dd, yy"
                            [inputStyle]="{'width':'95%'}" [readonlyInput]="true"
                            placeholder="Select Date"></p-calendar><img [calendarOpener]="calendarTopEndDateRef"
                            src="assets/images/date-calender.png" alt="calender"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 lg:col-2">
            <div class="date-outer">
                <label for="paymentStatus">Payment Status</label>
                <div class="custom-select2">
                    <div class="filter-parking header-filter financials-filter">
                        <p-dropdown [options]="selectStatus" id="paymentStatus" [(ngModel)]="searchStatus" optionLabel="name"
                            optionValue="value" (onChange)="onChangePaymentStatus($event)"></p-dropdown>
                        <img src="assets/images/fill-dropdown.svg" alt=""/>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="!showPicker" class="col-12 lg:col-2">
            <div class="date-outer">
                <label for="mcNumber">MC Number</label>
                <div class="custom-select2">
                    <div class="filter-parking header-filter">
                        <input (input)="numbersOnlyValidator($event)" id="mcNumber" type="text" [(ngModel)]="MCNumber" maxlength="15"
                            pInputText placeholder="Enter MC Number" />
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 lg:col-1">
            <div class="date-outer-btn">
                <div class="edit-outer">
                    <p-button styleClass="p-button search-button" (onClick)="search()" label="Search"></p-button>
                </div>
            </div>
        </div>
        <div class="col-12 lg:col-1">
            <div class="date-outer-btn">
                <div class="edit-outer reset-btn">
                    <p-button styleClass="p-button  p-button-outlined" (onClick)="reset()" label="Reset"></p-button>
                </div>
            </div>
        </div>
        <div *ngIf="showPicker"  (click)="toggleHideAdvanceFilter()" class="hide-advance">
            <h5 *ngIf="!hideAdvanceFilter">Hide Advanced Filter</h5>
            <h5 *ngIf="hideAdvanceFilter">Advanced Filter</h5>
        </div>
        <div *ngIf="!hideAdvanceFilter && showPicker" class="col-12 lg:col-2">
            <div class="date-outer">
                <label for="MCNumber">MC Number</label>
                <div class="custom-select2">
                    <div class="filter-parking header-filter">
                        <input (input)="numbersOnlyValidator($event)" id="MCNumber" type="text" [(ngModel)]="MCNumber" maxlength="15"
                            pInputText placeholder="Enter MC Number" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="overview-outer">
    <div class="col-12 md:col-6 lg:col-8 custom-spacing-right">
        <div class="revenue-outer">
            <div class="vparking-outer">
                <div class="top-heading">
                    <h4>Overview </h4>
                </div>

            </div>
            <p-chart type="line" [data]="revenueData" [options]="chartOptions"></p-chart>
        </div>
    </div>
    <div class="col-12 md:col-6 lg:col-4 custom-spacing-lright right-padding">
        <div class="driver-leaderb highest-payment">
            <div class="driver-outer">
                <div class="vparking-outer">
                    <div class="top-heading">
                        <h4>Highest Payer </h4>
                    </div>
                </div>
                <div class="dashboard-table custom-history no-record">
                    <div class="card">
                        <p-table [value]="highestPaymentData" [resizableColumns]="true" columnResizeMode="expand">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th scope="col" pSortableColumn="code">Name</th>
                                    <th scope="col" pSortableColumn="userType">User Type</th>
                                    <th scope="col" pSortableColumn="name">Amount (USD)</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rowData>
                                <tr class="border12">
                                    <td>
                                        <div class="driver-name history-table">
                                            <img [src]="rowData.driverImagePath || account" alt="Driver" />
                                            <p>{{ rowData.userType === 'Group Operator' ? rowData.groupCompanyName :
                                                rowData.driverName }}</p>
                                        </div>
                                    </td>
                                    <td>{{ rowData.userType }}</td>
                                    <td>{{ rowData.amount }}</td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage" let-columns>
                                <tr>
                                    <td class="no-record" colspan="4">
                                        No Record Found
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="driver-leaderb history-outer">
    <div class="grid">
        <div class="col-12 custom-spacing-right custom-leftright transaction-history">
            <div class="driver-outer">
                <div class="vparking-outer">
                    <div class="top-heading">
                        <h4>History - Bookings </h4>
                    </div>
                    <div class="record-outer">
                        <div class="page-list filter-parking">
                          <p>Show
                            <p-dropdown [options]="CustomItemPerPageBy" (onChange)="onDropdownChange($event)" placeholder="10"
                              optionLabel="name" optionValue="value" [(ngModel)]="SearchItemPerPageBy"></p-dropdown><img
                              src="assets/images/fill-dropdown.svg" alt="" />
                            Records
                          </p>
                        </div>
                        <div (click)="menu.toggle($event)" class="three-dot">
                          <img src="assets/images/dashboard-dot.svg" alt="" />
                        </div>
                      </div>

                </div>
                <div class="dashboard-table custom-history tranaction-history">
                    <div class="card full-width-scroll">
                        <p-table id="tbl-top" [tableStyle]="{'min-width': '60rem'}" [value]="transactionlist"
                            [resizableColumns]="true" columnResizeMode="expand">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th scope="col" class="driver-name">Name</th>
                                    <th scope="col" class="driver-email">Email</th>
                                    <th scope="col">User Type</th>
                                    <th scope="col">{{spotTypeMsg}}</th>
                                    <th scope="col">LP Number</th>
                                    <th scope="col">Invoice No.</th>
                                    <th scope="col">Company Name</th>
                                    <th scope="col">Parking Name</th>
                                    <th scope="col">Spot Count</th>
                                    <th scope="col">Booking Type</th>
                                    <th scope="col">Billing Cycle</th>
                                    <th scope="col">Arrival & Departure</th>
                                    <th scope="col">Base Amount
                                    </th>
                                    <th scope="col">Hazardous Load Charges</th>
                                    <th scope="col">Parking Discount
                                    </th>
                                    <th scope="col">Coupon Discount
                                    </th>
                                    <th scope="col">Taxes
                                    </th>
                                    <th scope="col">Transaction Fee</th>
                                    <th scope="col">Received ($)</th>
                                    <th scope="col">Payment Mode</th>
                                    <th scope="col">Received Date</th>
                                    <th scope="col">Received Time</th>
                                    <th scope="col">Refunded ($)</th>
                                    <th scope="col">Refunded Date & Time</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rowData>
                                <tr class="border12">
                                    <td>
                                        <div class="driver-name history-table">
                                            <img [src]="rowData.driverImagePath || account" alt="Driver" />
                                            <p>{{ rowData.userType === 'Group Operator' ? rowData.groupCompanyName :
                                                rowData.driverName }}</p>

                                        </div>
                                    </td>
                                    <td>{{ rowData.driverEmail }}</td>
                                    <td>{{ rowData.userType }}</td>
                                    <td>{{ rowData.equipmentType }}</td>
                                    <td>{{ rowData.licenseNumberPlate || '-'}}</td>
                                    <td>{{ rowData.invoiceNumber }}</td>
                                    <td>{{ rowData.companyName }}</td>
                                    <td>{{ rowData.parkingLotName }}</td>
                                    <td>{{rowData.spotCount}}</td>
                                    <td>{{ (rowData.bookingType > 0 || rowData.parentId != null) ? 'Recurring' : 'One Time' }}</td>
                                    <td>{{ (rowData.bookingType > 0 || rowData.parentId != null) ? rowData.billingCycle
                                        : "1" }}</td>
                                    <td>
                                        <div class="fin-custom-text">
                                            <h5>{{rowData.startDate | date:'MMM d, y - HH:mm' }}</h5>
                                            <p>{{rowData.endDate | date:'MMM d, y - HH:mm' }}</p>
                                        </div>
                                    </td>
                                    <td>{{ rowData.amount | removeDecimal}}</td>
                                    <td>{{ rowData.hazardousLoadCharge ?? '0' | removeDecimal}}</td>
                                    <td>{{ rowData.discount | removeDecimal}}</td>
                                    <td>{{ rowData.couponDiscount }}</td>
                                    <td>{{ rowData.taxAndFees | removeDecimal }}</td>
                                    <td>{{ rowData.transactionFees | removeDecimal}}</td>
                                    <td><div class="custom-green">{{rowData.receivedAmount | removeDecimal}}</div></td>
                                    <td>{{rowData.bookingPaymentMode | paymentModeValue}}</td>
                                      <td>
                                        {{ rowData.receivedDate ? rowData.receivedDate.split(' - ')[0] : '-' }}
                                    </td>
                                    <td>
                                        {{ rowData.receivedDate ? rowData.receivedDate.split(' - ')[1] : '-' }}
                                    </td>
                                    <td>
                                        <div [ngClass]="{'custom-red': (rowData.refundAmount !== 0 || (rowData.receivedAmount | removeDecimal) === 0)}">
                                          {{ (rowData.receivedAmount | removeDecimal) === 0 ? 0 : rowData.refundAmount === 0 ? '-' : (rowData.refundAmount | removeDecimal) }}
                                        </div>
                                    </td>
                                    <td><div class="refunded-text">{{ rowData.refundDate ? (rowData.refundDate  | luxonFormat) : '-' }}</div></td>
                            </ng-template>
                            <ng-template pTemplate="emptymessage" let-columns>
                                <tr>
                                    <td class="no-record" colspan="16">
                                        No Record Found
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>

                <div class="card common-content-end custom-pagination"
                    *ngIf="transactionlist?.length>0">
                    <p-paginator [first]="first" [rows]="itemsPerPage" [totalRecords]="totalItems"
                        (onPageChange)="onPageChange($event)"></p-paginator>
                </div>
            </div>

        </div>

    </div>

</div>
<div class="export-btn">
    <p-menu #menu [model]="items" click="export()" [popup]="true"></p-menu>
</div>